export default [
  {
    name: 'Свободная продажа',
    key: 'free',
  },
  {
    name: 'Альтернатива',
    key: 'alternative',
  },
];
